import React from 'react'
import { Button } from './styles'
import { message } from '~/services'

interface Props {
  onClick: React.MouseEventHandler<HTMLButtonElement>
}

export const ChangePregnancyButton = ({ onClick }: Props): JSX.Element => (
  <Button onClick={onClick}>{message('maternalInfant.change_pregnancy')}</Button>
)
